export default {
  "Clean": "Nettoyer",
  "Frees up storage space": "Libérer de l’espace de stockage",
  "Free space by deleting existing Events. This action cannot be undone.": "Libérez de l'espace en supprimant des événements existants. Cette action ne peut pas être annulée.",
  "Don't forget to download the records you want to keep.": "N'oubliez pas de télécharger les enregistrements que vous souhaitez conserver.",
  "Title": "Titre",
  "Date": "Date",
  "Storage size": "Taille de stockage",
  "Open project in a new tab": "Ouvrir le projet dans un nouvel onglet",
  "No projects are currently using media storage space": "Aucun projet n'utilise actuellement d'espace de stockage multimédia",
  "Cancel": "Annuler",
  "DELETE SELECTED EVENTS": "SUPPRIMER LES ÉVÉNEMENTS SÉLECTIONNÉS",
  "The following events will be definitively deleted :": "Les événements suivants seront définitivement supprimés :",
  "This will free up {space} of space.": "Cela libérera {space} d'espace.",
  "Please note that it may take a few minutes for the changes to fully apply.": "Veuillez noter que les changements peuvent prendre quelques minutes pour s'appliquer complètement."
}